<template>
    <label class="label" v-bind:class="style" v-bind:for="target">
        <slot>{{ text }}</slot>
    </label>
</template>

<style scoped>
.label {
    color: #6d6d6d;
    font-size: 12px;
    font-weight: 500;
    line-height: 15px;
}

.label.label-small {
    font-size: 11px;
    line-height: 13px;
}

.label.label-large {
    font-size: 14px;
    line-height: 16px;
}

.label.label-red,
.label.label-error {
    color: #e96760;
}
</style>

<script>
export const Label = {
    name: "label-ripe",
    props: {
        text: {
            type: String,
            mandatory: true
        },
        size: {
            type: String,
            default: "medium"
        },
        color: {
            type: String,
            default: null
        },
        target: {
            type: String,
            default: null
        }
    },
    computed: {
        style() {
            const base = {};
            if (this.size) base["label-" + this.size] = this.size;
            if (this.color) base["label-" + this.color] = this.color;
            return base;
        }
    }
};

export default Label;
</script>
